/**
 * This file contains all the query keys used by react-query,
 * such they can be referenced by name. Each key is an array or
 * function that returns and array, and subsction or variable
 * query params are concatenated onto the end of the array when
 * used in a query
 */

export const TEAM_MEMBERS = {
  LIST: ['team_members', 'list'],
  TYPEAHEAD_LIST: (include_service_accounts = false) => [
    'team_members',
    'list',
    'typeahead',
    include_service_accounts,
  ],
};

export const RELATION_FIELD = {
  RELATED_OBJECTS: (id) => ['related_objects', id],
};
